import { system } from '@eastcoal/common/config/system'
import { setupDayjsLocale } from '@eastcoal/common/utils/date'
import { normalizeUrl } from '@eastcoal/common/utils/url'

import { setupFormily } from '@eastcoal/formily/setup'

import {
  BUILD_MODE,
  API_SERVER_URL,
  WEB_OFFICE_APP_ID,
  OPERATION_BASE_URL,
  MEMBER_BASE_URL,
  MALL_BASE_URL,
  WEB_OFFICE_SERVER_URL,
  SUPPORT_BASE_URL,
  APP_VERSION
} from './utils/constants'

// 一定要保证该方法在所有页面加载之前执行
system.init({
  env: {
    appName: undefined,
    appType: undefined,
    appVersion: APP_VERSION,
    mode: BUILD_MODE,
    isProd: BUILD_MODE === 'prod'
  },
  api: {
    baseURL: API_SERVER_URL,
    timeout: 30000,
    ignore401: true
  },
  router: {
    mallBaseUrl: MALL_BASE_URL,
    memberBaseUrl: MEMBER_BASE_URL,
    operationBaseUrl: OPERATION_BASE_URL,
    supportBaseUrl: SUPPORT_BASE_URL,
    loginUrl: normalizeUrl(MEMBER_BASE_URL, '/login'),
    whitelist: ['/debugger']
  },
  webOffice: {
    serverUrl: WEB_OFFICE_SERVER_URL,
    appId: WEB_OFFICE_APP_ID
  }
})

system.setter.message({
  duration: 2
})

system.setter.notification({
  duration: 2
})

setupFormily()
setupDayjsLocale()
